import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { Divider } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import ListDetail from "./KRIAlertDetail";

import {extractData} from '../../util/TableUtil'

import moment from 'moment';

import setting from "../../config/setting";
import {styles} from '../CSS/Styles';



let counter = 0;
function createData(alertId, entity, creator, PO1, PO2, status, date) {
    counter += 1;
    return { alertId, entity, creator, PO1, PO2, status, date };
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


class EnhancedTableHead extends React.Component {

    constructor(props) {
        super(props);
        this.getTableHeader = this.getTableHeader.bind(this);
        this.state = {
            typename:null,
            rows: [],
        }
    }
    componentWillMount() {
        let pathtypename = this.props.type;
        // console.log(this.props);
        // console.log("header type name" + this.props.type);
        this.setState({typename: pathtypename});
    }
    componentDidMount() {
        this.getTableHeader();
    }
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };
    getTableHeader = () => {
        // if(this.state.typename == null){
        //     this.setState({ rows: [] });
        // }else{
        //     axios.get(config.alerts, {
        //         params:{ 'routine':this.state.typename 
        //     }
        //     })
        //         .then(res => {
        //             // console.log("alerts routine header" + this.state.typename);
        //             // console.log(res);
        //             let headers = res.data.table_def;
        //             this.setState({ rows: headers })
        //     });
        // }
        let header = ['No', 'KRI', 'Description', 'KRI Results', 'Status', 'Owner']
        this.setState({ rows: header })
    }

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow style={{whiteSpace:'nowrap'}}>
                    {this.state.rows.map(row => {
                        return (
                            <TableCell>
                                {row.replace(/_/g,' ')}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

class VendorAlertTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedetailriskname:"",
            typename: null,
            open: true,
            anchor: 'right',
            order: 'asc',
            orderBy: 'id',
            details: true,
            list: 7,
            selected: [],
            data: [
            ],
            fields: [],
            page: 0,
            rowsPerPage: 10,
            selectedAlert: createData('ABC Pte Ltd', [{
                name: "Confict Interest",
                avatar: "CI",
                color: "primary"
            }, {
                name: "Duplicate Address",
                avatar: "DA",
                color: "primary",
            }, {
                name: "Duplicate PO",
                avatar: "DP",
                color: "secondary"
            }
            ], 3.7, 67, 4.3, {
                high: 1,
                mid: 2,
                low: 3
            }),
            details: true,
            filtered: [],
            filter: 1
        };
        this.getAlerts = this.getAlerts.bind(this);


    }
    componentWillMount() {
        let pathtypename = this.props.type;
        this.setState({typename: pathtypename}) 
    }
    componentDidMount() {
        this.getAlerts();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.getAlerts();
            let pathtypename = this.props.type;
            this.setState({ typename: pathtypename })
        }
    }
    getAlerts() {
        // axios.get(config.alerts, {
        //     params:{'routine':this.props.type}
        // }).then(
        //     res => {
        //         // console.log("update routine with new data");
        //         // console.log(res.data.items);
        //         this.setState({
        //             data: res.data.items,
        //             filtered: res.data.items,
        //             fields: res.data.table_def,
        //             updatedetailID: res.data.items.length == 0 ? null : res.data.items.sort(getSorting(this.state.order, this.state.orderBy))[0]["id"]
        //         });
        //     }
        // )
        console.log(this.props.alert)
        let header = ['id', 'No', 'KRI', 'Description', 'KRI Results', 'Status', 'Owner']
        let databaseheader = ['id', 'risk_name', 'kri_id', 'description', 'risk_rating', 'status', 'owner']
        let filtered = extractData(this.props.alert, header, databaseheader)
        console.log("extracted data is")
        console.log(filtered)
        this.setState({filtered: filtered, fields: header})
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id, alert) => {
        // console.log("clicked ID is "+id);
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        this.setState({ selectedAlert: alert })
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };
    handleDetailClick(event, alert) {
        this.setState({selectedAlert: alert});
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    handleAction = event => {
        this.setState({ details: this.state.details ? false : true });
        this.setState({ list: this.state.list == 6 ? 12 : 6 });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    handleUpdateDetail = (kri) => {
        // console.log("clicked row with id " + id);
        let kriAlert = ''
        for (let keys in this.props.alert) {
            if ((this.props.alert)[keys].id == kri.id) {
                kriAlert = (this.props.alert)[keys]
            }
        }

        this.setState({ updatedetailriskname: kriAlert });
    };

    _onChangeSearch = (e) =>{
        //console.log(e.target.value);
        if (e.target.value){
            console.log(e.target.value);
            console.log(this.state.data);
            var filtered = this.state.data.filter(function(itm){
                return itm.description.toLowerCase().includes(e.target.value.toLowerCase())
            });
        } else {
            var filtered = this.state.data
        }
        
        //console.log(filtered);
        this.setState({filtered: filtered})
    };

    handleSlectionChange = (value)=>{
        this.setState({filter:value})
    }

    render() {
        const { classes, theme } = this.props;
        const { data, order, orderBy, selected, rowsPerPage, page, anchor, open, details, list , filtered,detailSelected}  = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, this.props.alert.length - page * rowsPerPage);
        // console.log("passing update row with id " + this.state.updatedetailID);
        //console.log('rows per page: '+rowsPerPage+'  page: '+page+'  emptyRows: '+emptyRows+'       '+(data.length - page * rowsPerPage))
        const detailsView = (<Grid item md={5} className={classes.contentWrapper}>
            <ListDetail threshold={this.props.threshold} data={this.props.data} alert={this.props.alert} risk={this.props.alert} kri={this.state.updatedetailriskname} update={this.props.update}/>
        </Grid>);

        return (
            <Paper className={classes.root}>
                <Grid container padding>
                    <Grid item md={list} className={classes.grid}>
                        <Typography color="inherit" variant="h7" style={{padding:'15px 0px 10px 20px', lineHeight:'70px', textAlign:'left'}}>
                            KRI Alert
                        </Typography>

                        <Card className={classes.tableWrapper} style={{display:'inline-block', width:'100%'}}>                            
                            <Table className={classes.table} aria-labelledby="tableTitle" padding='dense'>
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                    type={this.state.typename}
                                />
                                <TableBody>
                                    {filtered
                                        .sort(getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map(n => {
                                            const isSelected = this.isSelected(n.id);
                                            let i = 0;

                                            return (
                                                <TableRow
                                                    hover
                                                    aria-checked={isSelected}
                                                    tabIndex={-1}
                                                    key={n.id}
                                                    selected={isSelected}
                                                    onClick={()=>this.handleUpdateDetail(n)}
                                                >
                                                    {
                                                        this.state.fields.map(f => {
                                                            //if (this.state.filter == 1 && n.Tier !='Tier1' || this.state.filter == 2 && n.Tier =='Tier1' ) {
                                                            //    return null
                                                            //}
                                                            if (f=='id') {
                                                                return null
                                                            }
                                                            if (f=='KRI Results') {
                                                                return (
                                                                    <TableCell>
                                                                        <Typography style={{color:n[f] === 'Red' ? setting.COLOR.RED : n[f] === 'Amber' ? setting.COLOR.AMBER : setting.COLOR.GREEN}}>
                                                                            {n[f]}
                                                                        </Typography>
                                                                    </TableCell>)
                                                            }
                                                            return (<TableCell style={{whiteSpace: f=='Description'? null : 'nowrap'}} onClick={event => this.handleDetailClick(event, n)}>{f == "created_date" ? moment(n[f]).format(setting.date_format):n[f]}</TableCell>);
                                                        })
                                                    }
                                                </TableRow>
                                            );
                                        })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 49 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <TablePagination
                                component="div"
                                count={filtered.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            /> 
                        </Card>
                    </Grid>
                    {this.state.details ? detailsView : null}
                </Grid>
                <Divider />
            </Paper>
        );
    }
}

VendorAlertTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VendorAlertTable);


// WEBPACK FOOTER //
// ./src/components/KRI/KRIAlertSummary.js